// Arizona State University's undergraduate majors (#2743). Read on
// 2026-10-01 from ASU's official Degree Search (degrees.asu.edu/bachelors),
// through the feed that page itself loads (degreesearch-proxy.apps.asu.edu,
// method findAllDegrees, program=undergrad, cert=false). Kept: every
// bachelor's plan offered on an in-person campus (Tempe, Downtown Phoenix,
// Polytechnic, West Valley or ASU at Los Angeles). Left out: ASU Online-only
// and ASU Sync-only plans, associate degrees, exploratory and pre-law
// tracks (no degree) and the Barrett honors college entry (not a major).
// ASU lists each concentration as its own plan, written "Major
// (Concentration)"; those are folded into the major, so one major and degree
// appears once per college. Degree abbreviations are the Degree Search's own
// (BS, BA, BSE, BFA, ...). College names are written in their usual order
// ("W. P. Carey School of Business"), not the feed's inverted form. The KB's
// majors list was the starting point; the official list wins.
const majors = {
    "slug": "arizona-state-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major ASU's official Degree Search lists on its in-person campuses, grouped by the college that offers it, with the degree it leads to. Concentrations are folded into their major. Online-only programs, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Health Solutions",
            "source": {
                "label": "ASU Degree Search, undergraduate degrees",
                "url": "https://degrees.asu.edu/bachelors"
            },
            "majors": [
                {
                    "name": "Applied Nutrition and Health",
                    "degree": "BS"
                },
                {
                    "name": "Applied Science",
                    "degree": "BAS"
                },
                {
                    "name": "Biomedical Informatics and Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Clinical Exercise Science",
                    "degree": "BS"
                },
                {
                    "name": "Dietetics",
                    "degree": "BS"
                },
                {
                    "name": "Health Care Administration and Policy",
                    "degree": "BS"
                },
                {
                    "name": "Health Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Kinesiology",
                    "degree": "BS"
                },
                {
                    "name": "Medical Studies",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Nutritional Science",
                    "degree": "BS"
                },
                {
                    "name": "Population Health",
                    "degree": "BS"
                },
                {
                    "name": "Speech and Hearing Science",
                    "degree": "BS"
                },
                {
                    "name": "Sports Science and Performance Programming",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "College of Integrative Sciences and Arts",
            "source": {
                "label": "ASU Degree Search, undergraduate degrees",
                "url": "https://degrees.asu.edu/bachelors"
            },
            "majors": [
                {
                    "name": "Applied Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Applied Military and Veterans Studies",
                    "degree": "BA"
                },
                {
                    "name": "Applied Physics",
                    "degree": "BS"
                },
                {
                    "name": "Applied Quantitative Science",
                    "degree": "BS"
                },
                {
                    "name": "Applied Science",
                    "degree": "BAS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Counseling and Applied Psychological Science",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "General Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History of Science, Technology and Innovation",
                    "degree": "BA"
                },
                {
                    "name": "Integrative Social Science",
                    "degree": "BS"
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "BA"
                },
                {
                    "name": "Liberal Studies",
                    "degree": "BA"
                },
                {
                    "name": "Organizational Leadership",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Project Management",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Science, Technology and Society",
                    "degree": "BS"
                },
                {
                    "name": "Technical Communication",
                    "degree": "BS"
                },
                {
                    "name": "User Experience",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Edson College of Nursing and Health Innovation",
            "source": {
                "label": "ASU Degree Search, undergraduate degrees",
                "url": "https://degrees.asu.edu/bachelors"
            },
            "majors": [
                {
                    "name": "Applied Science",
                    "degree": "BAS"
                },
                {
                    "name": "Community Health",
                    "degree": "BS"
                },
                {
                    "name": "Health Care Compliance and Regulations",
                    "degree": "BS"
                },
                {
                    "name": "Health Care Coordination",
                    "degree": "BS"
                },
                {
                    "name": "Health Entrepreneurship and Innovation",
                    "degree": "BS"
                },
                {
                    "name": "Integrative Health",
                    "degree": "BS"
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "Herberger Institute for Design and the Arts",
            "source": {
                "label": "ASU Degree Search, undergraduate degrees",
                "url": "https://degrees.asu.edu/bachelors"
            },
            "majors": [
                {
                    "name": "Architectural Studies",
                    "degree": "BSD"
                },
                {
                    "name": "Art",
                    "degree": "BA"
                },
                {
                    "name": "Art",
                    "degree": "BFA"
                },
                {
                    "name": "Arts",
                    "degree": "BA"
                },
                {
                    "name": "Costume Design and Technology for the Creative Industries",
                    "degree": "BFA"
                },
                {
                    "name": "Dance",
                    "degree": "BFA"
                },
                {
                    "name": "Environmental Design",
                    "degree": "BS"
                },
                {
                    "name": "Fashion",
                    "degree": "BA"
                },
                {
                    "name": "Film",
                    "degree": "BA"
                },
                {
                    "name": "Film and Media Production",
                    "degree": "BFA"
                },
                {
                    "name": "Game Design",
                    "degree": "BS"
                },
                {
                    "name": "Game Studio Production",
                    "degree": "BS"
                },
                {
                    "name": "Graphic Design",
                    "degree": "BSD"
                },
                {
                    "name": "Industrial Design",
                    "degree": "BSD"
                },
                {
                    "name": "Interior Design",
                    "degree": "BSD"
                },
                {
                    "name": "Landscape Architecture",
                    "degree": "BSLA"
                },
                {
                    "name": "Media Arts and Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Media Arts and Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music Learning and Teaching",
                    "degree": "BMUS"
                },
                {
                    "name": "Music Therapy",
                    "degree": "BMUS"
                },
                {
                    "name": "Performance",
                    "degree": "BMUS"
                },
                {
                    "name": "Performance and Movement",
                    "degree": "BA"
                },
                {
                    "name": "Theatre",
                    "degree": "BA"
                },
                {
                    "name": "Theory and Composition",
                    "degree": "BMUS"
                }
            ]
        },
        {
            "name": "Ira A. Fulton Schools of Engineering",
            "source": {
                "label": "ASU Degree Search, undergraduate degrees",
                "url": "https://degrees.asu.edu/bachelors"
            },
            "majors": [
                {
                    "name": "Aeronautical Management Technology",
                    "degree": "BS"
                },
                {
                    "name": "Aerospace Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Applied Science",
                    "degree": "BAS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Computer Systems Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Construction Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Construction Management and Technology",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Engineering Management",
                    "degree": "BSE"
                },
                {
                    "name": "Engineering Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Environmental and Resource Management",
                    "degree": "BS"
                },
                {
                    "name": "Graphic Information Technology",
                    "degree": "BS"
                },
                {
                    "name": "Human Systems Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Informatics",
                    "degree": "BS"
                },
                {
                    "name": "Information Technology",
                    "degree": "BS"
                },
                {
                    "name": "Manufacturing Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Manufacturing Systems",
                    "degree": "BAS"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Robotics and Autonomous Systems",
                    "degree": "BS"
                },
                {
                    "name": "Robotics and Autonomous Systems",
                    "degree": "BSE"
                },
                {
                    "name": "Software Engineering",
                    "degree": "BS"
                },
                {
                    "name": "Technological Entrepreneurship and Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Mary Lou Fulton College for Teaching and Learning Innovation",
            "source": {
                "label": "ASU Degree Search, undergraduate degrees",
                "url": "https://degrees.asu.edu/bachelors"
            },
            "majors": [
                {
                    "name": "Early Childhood Education",
                    "degree": "BAE"
                },
                {
                    "name": "Education",
                    "degree": "BED"
                },
                {
                    "name": "Educational Studies",
                    "degree": "BAE"
                },
                {
                    "name": "Elementary Education",
                    "degree": "BAE"
                },
                {
                    "name": "Elementary Multilingual Education",
                    "degree": "BAE"
                },
                {
                    "name": "Middle Grades Education",
                    "degree": "BAE"
                },
                {
                    "name": "Physical Education",
                    "degree": "BAE"
                },
                {
                    "name": "Secondary Education",
                    "degree": "BAE"
                },
                {
                    "name": "Special Education",
                    "degree": "BAE"
                }
            ]
        },
        {
            "name": "New College of Interdisciplinary Arts and Sciences",
            "source": {
                "label": "ASU Degree Search, undergraduate degrees",
                "url": "https://degrees.asu.edu/bachelors"
            },
            "majors": [
                {
                    "name": "Aging",
                    "degree": "BS"
                },
                {
                    "name": "Applied Computing",
                    "degree": "BS"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Applied Science",
                    "degree": "BAS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Biotechnology and Bioenterprise",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BS"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Conflict Resolution",
                    "degree": "BA"
                },
                {
                    "name": "Digital Forensics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Science",
                    "degree": "BS"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "Forensic Science",
                    "degree": "BS"
                },
                {
                    "name": "Gender, Women and Sexuality Studies",
                    "degree": "BS"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Arts and Performance",
                    "degree": "BA"
                },
                {
                    "name": "Interdisciplinary Arts and Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Pharmacology and Toxicology",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy, Religion and Society",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Social Justice and Human Rights",
                    "degree": "BA"
                },
                {
                    "name": "Social and Behavioral Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Social and Behavioral Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Social and Cultural Analysis",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Rob Walton College of Global Futures",
            "source": {
                "label": "ASU Degree Search, undergraduate degrees",
                "url": "https://degrees.asu.edu/bachelors"
            },
            "majors": [
                {
                    "name": "Complexity Science",
                    "degree": "BS"
                },
                {
                    "name": "Conservation",
                    "degree": "BS"
                },
                {
                    "name": "Innovation in Society",
                    "degree": "BA"
                },
                {
                    "name": "Innovation in Society",
                    "degree": "BS"
                },
                {
                    "name": "Ocean Futures",
                    "degree": "BS"
                },
                {
                    "name": "Sustainability",
                    "degree": "BA"
                },
                {
                    "name": "Sustainability",
                    "degree": "BS"
                },
                {
                    "name": "Sustainable Food Systems",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "School of Technology for Public Health",
            "source": {
                "label": "ASU Degree Search, undergraduate degrees",
                "url": "https://degrees.asu.edu/bachelors"
            },
            "majors": [
                {
                    "name": "Public Health",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "The College of Liberal Arts and Sciences",
            "source": {
                "label": "ASU Degree Search, undergraduate degrees",
                "url": "https://degrees.asu.edu/bachelors"
            },
            "majors": [
                {
                    "name": "Actuarial Science",
                    "degree": "BS"
                },
                {
                    "name": "African and African American Studies",
                    "degree": "BA"
                },
                {
                    "name": "American Indian Studies",
                    "degree": "BS"
                },
                {
                    "name": "American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BS"
                },
                {
                    "name": "Asia Studies",
                    "degree": "BA"
                },
                {
                    "name": "Asian Languages",
                    "degree": "BA"
                },
                {
                    "name": "Asian Pacific American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Biophysics",
                    "degree": "BS"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Civic and Economic Thought and Leadership",
                    "degree": "BA"
                },
                {
                    "name": "Civic and Economic Thought and Leadership",
                    "degree": "BS"
                },
                {
                    "name": "Communication",
                    "degree": "BA"
                },
                {
                    "name": "Communication",
                    "degree": "BS"
                },
                {
                    "name": "Computational Mathematical Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Culture, Technology and Environment",
                    "degree": "BA"
                },
                {
                    "name": "Data Science",
                    "degree": "BS"
                },
                {
                    "name": "Earth and Environmental Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Earth and Environmental Sciences",
                    "degree": "BS"
                },
                {
                    "name": "Earth and Space Exploration",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Family and Human Development",
                    "degree": "BS"
                },
                {
                    "name": "Film",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "Gender, Women and Sexuality Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geographic Information Science",
                    "degree": "BS"
                },
                {
                    "name": "Geography",
                    "degree": "BA"
                },
                {
                    "name": "Geography",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Global Asia Studies",
                    "degree": "BA"
                },
                {
                    "name": "Global Citizenship",
                    "degree": "BA"
                },
                {
                    "name": "Global Health",
                    "degree": "BA"
                },
                {
                    "name": "Global Health",
                    "degree": "BS"
                },
                {
                    "name": "Global Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "Integrated Studies",
                    "degree": "BA"
                },
                {
                    "name": "Integrated Studies",
                    "degree": "BS"
                },
                {
                    "name": "International Letters and Cultures",
                    "degree": "BA"
                },
                {
                    "name": "International Relations",
                    "degree": "BA"
                },
                {
                    "name": "International Relations",
                    "degree": "BS"
                },
                {
                    "name": "Italian",
                    "degree": "BA"
                },
                {
                    "name": "Jewish Studies",
                    "degree": "BA"
                },
                {
                    "name": "Justice Studies",
                    "degree": "BA"
                },
                {
                    "name": "Justice Studies",
                    "degree": "BS"
                },
                {
                    "name": "Latin American Studies",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Microbiology",
                    "degree": "BS"
                },
                {
                    "name": "Molecular Biosciences and Biotechnology",
                    "degree": "BS"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Political Science",
                    "degree": "BS"
                },
                {
                    "name": "Politics and the Economy",
                    "degree": "BS"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BS"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Russian",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BS"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Technological Leadership",
                    "degree": "BS"
                },
                {
                    "name": "Transborder Chicana/o and Latina/o Studies",
                    "degree": "BA"
                },
                {
                    "name": "Urban Planning",
                    "degree": "BSP"
                }
            ]
        },
        {
            "name": "Thunderbird School of Global Management",
            "source": {
                "label": "ASU Degree Search, undergraduate degrees",
                "url": "https://degrees.asu.edu/bachelors"
            },
            "majors": [
                {
                    "name": "Global Management",
                    "degree": "BGM"
                },
                {
                    "name": "International Trade",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "W. P. Carey School of Business",
            "source": {
                "label": "ASU Degree Search, undergraduate degrees",
                "url": "https://degrees.asu.edu/bachelors"
            },
            "majors": [
                {
                    "name": "Accountancy",
                    "degree": "BS"
                },
                {
                    "name": "Applied Business and Technology Solutions",
                    "degree": "BA"
                },
                {
                    "name": "Artificial Intelligence in Business",
                    "degree": "BS"
                },
                {
                    "name": "Business",
                    "degree": "BA"
                },
                {
                    "name": "Business Data Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Business Entrepreneurship",
                    "degree": "BS"
                },
                {
                    "name": "Computer Information Systems",
                    "degree": "BS"
                },
                {
                    "name": "Economics",
                    "degree": "BS"
                },
                {
                    "name": "Entrepreneurial Leadership",
                    "degree": "BA"
                },
                {
                    "name": "Finance",
                    "degree": "BS"
                },
                {
                    "name": "Financial Technology",
                    "degree": "BS"
                },
                {
                    "name": "Management",
                    "degree": "BS"
                },
                {
                    "name": "Marketing",
                    "degree": "BS"
                },
                {
                    "name": "Real Estate and Applied Finance",
                    "degree": "BS"
                },
                {
                    "name": "Supply Chain Management",
                    "degree": "BS"
                }
            ]
        },
        {
            "name": "Walter Cronkite School of Journalism and Mass Communication",
            "source": {
                "label": "ASU Degree Search, undergraduate degrees",
                "url": "https://degrees.asu.edu/bachelors"
            },
            "majors": [
                {
                    "name": "Content Creation",
                    "degree": "BA"
                },
                {
                    "name": "Digital Strategy and Audience Engagement",
                    "degree": "BS"
                },
                {
                    "name": "Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Mass Communication and Media Studies",
                    "degree": "BA"
                },
                {
                    "name": "Science Communication",
                    "degree": "BA"
                },
                {
                    "name": "Sports Journalism",
                    "degree": "BA"
                },
                {
                    "name": "Sports Strategic Communication",
                    "degree": "BA"
                },
                {
                    "name": "Strategic Communication",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Watts College of Public Service and Community Solutions",
            "source": {
                "label": "ASU Degree Search, undergraduate degrees",
                "url": "https://degrees.asu.edu/bachelors"
            },
            "majors": [
                {
                    "name": "Applied Science",
                    "degree": "BAS"
                },
                {
                    "name": "Community Advocacy and Social Policy",
                    "degree": "BA"
                },
                {
                    "name": "Community Sports Management",
                    "degree": "BS"
                },
                {
                    "name": "Criminology and Criminal Justice",
                    "degree": "BS"
                },
                {
                    "name": "Emergency Management and Homeland Security",
                    "degree": "BS"
                },
                {
                    "name": "Nonprofit Leadership and Management",
                    "degree": "BS"
                },
                {
                    "name": "Parks, Recreation and Sport Management",
                    "degree": "BS"
                },
                {
                    "name": "Public Service and Public Policy",
                    "degree": "BS"
                },
                {
                    "name": "Recreational Therapy",
                    "degree": "BS"
                },
                {
                    "name": "Social Work",
                    "degree": "BSW"
                },
                {
                    "name": "Tourism Development and Management",
                    "degree": "BS"
                },
                {
                    "name": "Urban and Metropolitan Studies",
                    "degree": "BS"
                }
            ]
        }
    ]
};

export default majors;
